
export default {
  props: {
    tenderId: {
      type: String,
      required: true
    },

    lotNumber: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      projects: {},

      loading: false
    };
  },

  fetchOnServer: false,

  async fetch () {
    try {
      if (this.$user.platform !== 'Sero') {
        return;
      }

      const { id } = await this.$axios.$get(`/project/exists/${this.tenderId}/${this.lotNumber}`);

      this.$set(this.projects, this.lotNumber, id);
    } catch {
      this.$set(this.projects, this.lotNumber, null);
    }
  },

  watch: {
    lotNumber () {
      if (this.projects[this.lotNumber] !== undefined) { return; }

      this.$fetch();
    }
  },

  methods: {
    async addToMyTenders (destination) {
      this.loading = true;
      try {
        const { id } = await this.$axios.$post('/project', {
          tenderId: this.tenderId,
          lotNumber: this.lotNumber
        });

        this.$router.push({ path: '/collaborate/my-tenders', query: { destination }, hash: `#project-${id}` });
      } catch (e) {
        this.$toast({ error: true, title: 'Er ging iets mis tijdens het toevoegen.', subtitle: 'Probeer het later opnieuw.' });
      }

      this.loading = false;
    }
  }
};
